import { Controller } from "@hotwired/stimulus"

// Client-side filtering for the control matrix. Each control row exposes
// `data-control-id`, `data-control-title` and `data-control-text` (all
// lower-cased) so we can do a fast substring match without any network calls.
// Theme blocks hide themselves when none of their rows match the query.
export default class extends Controller {
  static targets = ["filter", "row", "themeBlock"]

  filter() {
    const q = this.filterTarget.value.trim().toLowerCase()
    this.rowTargets.forEach((row) => {
      const haystack = [
        row.dataset.controlId.toLowerCase(),
        row.dataset.controlTitle,
        row.dataset.controlText
      ].join(" ")
      row.hidden = q.length > 0 && !haystack.includes(q)
    })
    this.themeBlockTargets.forEach((block) => {
      const visible = block.querySelectorAll('[data-control-matrix-target="row"]:not([hidden])').length
      block.hidden = visible === 0
    })
  }
}
